import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ProjectTestQuestionApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'project-test-question'
  }

}